
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 48 48"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"transform":"matrix(2,0,0,2,0,0)"}},[_c('defs',[_c('style',[_v('.a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}')])]),_c('title',[_v('road-sign-stop')]),_c('polyline',{staticClass:"a",attrs:{"points":"21.75 5.84 16.66 0.75 7.34 0.75 2.25 5.84"}}),_c('polyline',{staticClass:"a",attrs:{"points":"2.25 18.16 7.34 23.25 16.66 23.25 21.75 18.16"}}),_c('line',{staticClass:"a",attrs:{"x1":"9","y1":"15","x2":"9","y2":"9"}}),_c('line',{staticClass:"a",attrs:{"x1":"7.5","y1":"9","x2":"10.5","y2":"9"}}),_c('line',{staticClass:"a",attrs:{"x1":"18.75","y1":"15","x2":"18.75","y2":"9"}}),_c('path',{staticClass:"a",attrs:{"d":"M14.25,9a1.5,1.5,0,0,0-1.5,1.5v3a1.5,1.5,0,0,0,3,0v-3A1.5,1.5,0,0,0,14.25,9Z"}}),_c('path',{staticClass:"a",attrs:{"d":"M5.25,9H3.75a1.5,1.5,0,0,0-1.5,1.5c0,2.25,3,.75,3,3A1.5,1.5,0,0,1,3.75,15H2.25"}}),_c('path',{staticClass:"a",attrs:{"d":"M18.75,9h1.125a1.875,1.875,0,0,1,0,3.75H18.75"}})])])
          )
        }
      }
    